import React from 'react';
import { MenuLink } from '@src/modules/Layout/shared/MenuLink';
import { DASHBOARD_ROUTES } from '../../constants';
import { Icon } from '@therms/atalaya';
import { MdSpaceDashboard } from 'react-icons/md';

function DashboardMenuLink() {
  return (
    <MenuLink to={DASHBOARD_ROUTES.__ROOT__}>
      <div className="inline-flex items-center gap-x-sm">
        <Icon Icon={MdSpaceDashboard} />
        <span>Dashboard</span>
      </div>
    </MenuLink>);

}

export { DashboardMenuLink };